<template>    
    <div class="item">
        <div class="columns is-centered ">
            <div class="column is-8 wrapper" @click="openLink()">
                    <h3 class="subtitle is-center is-5">{{ item.title }}</h3>
                
                <figure class="image">
                    <img :src="getImg()" alt="">
                </figure>
                

                    <ul class="tags is-center">
                        <li class="tag is-danger" v-for="(tag, index) in item.tags" :key="index">{{ tag }}</li>
                    </ul> 

                    <p class="is-center description" style="color : #dddddd;">{{ item.description }}</p>
                
            </div>
        </div>
    </div>  
</template>

<script>
    export default {
        name : 'SinglePortfolio',
        props : {
            item : {
                default : {}
            }
        },
        methods: {
            getImg () {                
                if (this.item.image) {
                    var images = require.context('../assets/', false, /\.png$/)
                    return images('./' + this.item.image)                 
                }
            },
            openLink () {
                window.open(this.item.link, '_blank');
            }
        },
    }
</script>

<style scoped lang="scss">
.item{
    
    

    cursor: pointer;

    .wrapper{
        transition: all 0.5s;
        padding-bottom: 50px;
        margin-top:  20px;
        background-image: linear-gradient(0deg,#704bb4,#6441a5);
        -webkit-box-shadow: 10px -7px 13px 0px rgba(0,0,0,0.2);
        -moz-box-shadow: 10px -7px 13px 0px rgba(0,0,0,0.2);
        box-shadow: 10px -7px 13px 0px rgba(0,0,0,0.2);
        border-radius: 0.5em;
    }

   .wrapper:hover{
      
        -moz-transform: translate(0px, -10px);
        -webkit-transform: translate(0px, -10px);
        -o-transform: translate(0px, -10px);
        -ms-transform: translate(0px, -10px);
        transform: translate(0px, -10px);
   }

   .content {
       padding: 10px;
   }
}
ul {
    margin-left: 0;
    margin-top: 0; 
}
.tags{
    display: flex;
    justify-content: center;
}
.subtitle{
    margin-top: 0 !important;
}

</style>


// WEBPACK FOOTER //
// src/componests/SinglePortfolio.vue